// main modules
export * from './directives';
export * from './services';
// core module
export { AdmCoreModule } from './core.module';
//# sourceMappingURL=index.js.map